import React, { ChangeEventHandler, ReactElement } from 'react';
import styles from '../consumer-review-dialog.module.scss';
import { CUIText } from '@dotcom/crown-ui';

type ConsumerReviewCheckProps = {
  isConsumerReviewChecked: boolean;
  onCheckboxChange: ChangeEventHandler<HTMLInputElement>;
  checkboxLabel: string;
};

export const ConsumerReviewCheck = ({
  checkboxLabel,
  isConsumerReviewChecked,
  onCheckboxChange,
}: ConsumerReviewCheckProps): ReactElement => (
  <div className={styles['consumer-description-container']}>
    <input
      type="checkbox"
      id="acknowledge-checkbox"
      className={styles['consumer-review-checkbox']}
      data-testid="consumer-review-checkbox"
      checked={isConsumerReviewChecked}
      onChange={onCheckboxChange}
    />
    <CUIText variant="form" htmlFor="acknowledge-checkbox">
      {checkboxLabel}
    </CUIText>
  </div>
);
